// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface IGameDetailTabDataState {
  defaultActiveId: 'gameDetail';
  tab: string;
  filter: Record<string, any>;
}

type IUpdateTabAction = Action<'updateTab'> & IPayload<string>;
type IUpdateFilterAction = Action<'updateFilter'> & IPayload<Record<string, any>>;
type IClearFilterAction = Action<'clearFilter'>;

interface IGameDetailTabDataModel {
  namespace: string;
  state: IGameDetailTabDataState;
  reducers: {
    updateTab: Reducer<IGameDetailTabDataState, IUpdateTabAction>;
    updateFilter: Reducer<IGameDetailTabDataState, IUpdateFilterAction>;
    clearFilter: Reducer<IGameDetailTabDataState, IClearFilterAction>;
  };
  effects: {};
}

export const GAME_DETAIL_TAB_DATA_MODEL_NAMESPACE = 'dbg-model-game-detail-tab-data';

const GameDetailTabDataModel: IGameDetailTabDataModel = {
  namespace: GAME_DETAIL_TAB_DATA_MODEL_NAMESPACE,
  state: {
    defaultActiveId: 'gameDetail',
    tab: 'gameDetail',
    filter: {},
  },
  reducers: {
    updateTab(state, action) {
      const { payload } = action || {};
      if (!payload) return { ...state };
      return { ...state, tab: payload };
    },
    updateFilter(state, action) {
      return { ...state, filter: action?.payload || {} };
    },
    clearFilter(state) {
      return { ...state, filter: {} };
    },
  },
  effects: {},
};

export default GameDetailTabDataModel;
